import React from "react";
import "../CampaignStep.css";
import Location from "./Location/Location";

const CampaignStep1 = () => {
  return (
    <div className="campaignStep1">
      <Location />
    </div>
  );
};

export default CampaignStep1;
